<sfx-navigation-toolbar (closeEvent)="close()">
    <div navigationToolbarTitle translate>
        Customize fields
    </div>
    <a navigationToolbarButton icon="sf-icon-accounts" ref=".account">
        {{ "Account" | translate }}
    </a>
    <a navigationToolbarButton icon="sf-icon-contact" ref=".contact">
        {{ "Contact" | translate }}
    </a>
    <a navigationToolbarButton icon="sf-icon-opportunities" ref=".opportunity">
        {{ "Opportunity" | translate }}
    </a>
</sfx-navigation-toolbar>

<sfx-content>
    <sfx-section disableContentPadding>
        <ui-view></ui-view>
    </sfx-section>
</sfx-content>